import { Pipe, PipeTransform } from '@angular/core';

import { StatusKonfiguracjiDyplomowania } from '@interfaces/dyplomowanie/enums/status-konfiguracji-dyplomowania.enum';

@Pipe({
  name: 'statusKonfiguracjiText',
})
export class StatusKonfiguracjiTextPipe implements PipeTransform {
  transform(value: number): string {
    const { Przestarzala, Aktualna, Przyszla } = StatusKonfiguracjiDyplomowania;
    switch (value) {
      case Przestarzala:
        return $localize`przestarzała`;
      case Aktualna:
        return $localize`aktualna`;
      case Przyszla:
        return $localize`przyszła`;
      default:
        return '';
    }
  }
}
